import React from 'react'
import { ImCross } from 'react-icons/im'
export default function Popup(props) {
    return (
        <div className="popup-parent row mx-0 pt-5" >
            <div className="card g-card col-lg-7 col-11">
                <div className="card-body w-100">
                    <div className="d-flex justify-content-between align-items-center pb-3 pt-2 ">
                        <span className="text-center fs-5" style={{flex:"1"}}>
                            Connect Wallet
                        </span>
                        <ImCross className="cross-icon" onClick={()=>{props.passState(0)}} style={{ fontSize: "14px" ,cursor:"pointer"}} />
                    </div>

                    <div className="row px-lg-3 m-0 mt-4">
                        <div className="col-lg-3 col-md-6 col-12  p-2 ">
                            <div className="poppup-box">
                                <div className="badge">Soon</div>
                                <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} alt="" />
                                <span className="text-faded text-uppercase pt-3">reaper wallet</span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12  p-2 ">
                            <div className="poppup-box">
                                <img src={process.env.PUBLIC_URL + "/assets/images/p-icon-3.png"} alt="" />
                                <span className="text-faded text-uppercase pt-3">meta mask</span>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12  p-2 ">
                            <div className="poppup-box">
                                <img src={process.env.PUBLIC_URL + "/assets/images/p-icon-2.png"} alt="" />
                                <span className="text-faded text-uppercase pt-4 mt-2">Wallet Connect</span>
                            </div>
                        </div>
             
                        <div className="col-lg-3 col-md-6 col-12  p-2 ">
                            <div className="poppup-box">
                                <img src={process.env.PUBLIC_URL + "/assets/images/dot.png"} className="mt-3" alt="" />
                                <span className="text-faded text-uppercase pt-3 mt-3">more</span>
                            </div>
                        </div>
                        <div className=" text-small pt-2 mt-2 text-faded-2 w-100 text-center">
                            Haven’t got a crypto wallet yet?
                        </div>
                        <div className="d-flex justify-content-center py-3">
                            <button className="g-btn">Connect Wallet</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
